import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { ApplicationVersionTO } from "src/app/data/schema/Application/ApplicationVersionTO";
import { environment } from "src/environments/environment";
import { PlatformLocation } from "@angular/common";
declare let versionBuild: ApplicationVersionTO;

@Injectable({
    providedIn: "root"
})
export class UpdateApplicationService {
    public showMessageForUpdate = false;
    public newVersion = null;

    constructor(private http: HttpClient, private platformLocation: PlatformLocation) {
        setInterval(() => {
            this.CheckNewVersionAndShowMessage();
        }, 1000 * 60);
    }

    private getBaseHref() {
        return this.platformLocation.getBaseHrefFromDOM();
    }

    public GetVersionRemote(): Observable<ApplicationVersionTO> {
        const min = 1;
        const max = 10000000;

        if (environment.checkVersion == false) return;

        return this.http.get<ApplicationVersionTO>(
            `${location.origin}${this.getBaseHref()}version.json?rnd=${min + Math.floor((max - min) * Math.random())}`
        );
    }

    public GetVersionLocalOld(): string {
        return localStorage.getItem("versionOld");
    }

    public GetVersionThis(): string {
        if (versionBuild.Date == "DATE_BUILD_1a0d837085634e0db851edbf9d8d4c4f") {
            // Simulação
            return "2021-02-25 17:24:20";
        }

        return versionBuild.Date;
    }

    public IsNewVersion(): Observable<boolean> {
        if (environment.checkVersion == false) return;
        return new Observable<boolean>((observable) => {
            this.GetVersionRemote().subscribe(
                (applicationVersion) => {
                    const isNewVersion = applicationVersion.Date != this.GetVersionThis();

                    observable.next(isNewVersion);

                    if (isNewVersion) {
                        this.newVersion = applicationVersion.Date;
                        console.info(`Versao Atual ${applicationVersion.Date} versão nova ${this.GetVersionThis()}`);
                    } else {
                        this.newVersion = null;
                        localStorage.setItem("newVersion", null);
                    }
                },
                (err) => {
                    observable.error(err);
                },
                () => {
                    observable.complete();
                }
            );
        });
    }

    public CheckNewVersionAndUpdate(): void {
        if (environment.checkVersion == false) return;
        this.IsNewVersion().subscribe((isNewVersion) => {
            if (isNewVersion) {
                console.info("Atualizando versão");

                if (localStorage.getItem("newVersion") == this.newVersion) {
                    console.info(`Falha na atualização`);
                    return;
                }

                localStorage.setItem("newVersion", this.newVersion);

                setTimeout(() => {
                    try {
                        location.reload();
                    } catch (err) {
                        location.reload();
                    }
                }, 5000);
            }
        });
    }

    public CheckNewVersionAndShowMessage(): void {
        if (environment.checkVersion == false) return;
        this.IsNewVersion().subscribe((isNewVersion) => {
            this.showMessageForUpdate = isNewVersion;
        });
    }
}
